 export const production = {
  API_URL_MOTOR: process.env.REACT_APP_API_URL_MOTOR,
  API_URL_MOTOR_8080: process.env.REACT_APP_API_URL_MOTOR_8080,
  API_URL_INJECTOR: process.env.REACT_APP_API_URL_INJECTOR,
  API_URL_BACKEND: process.env.REACT_APP_API_URL_BACKEND,
  API_URL_BACKEND_ECS: process.env.REACT_APP_API_URL_BACKEND_ECS
  };
  
  export const development = {
    API_URL_MOTOR: process.env.REACT_APP_API_URL_MOTOR,
    API_URL_MOTOR_8080: process.env.REACT_APP_API_URL_MOTOR_8080,
    API_URL_INJECTOR: process.env.REACT_APP_API_URL_INJECTOR,
    API_URL_BACKEND: process.env.REACT_APP_API_URL_BACKEND,
    API_URL_BACKEND_ECS: process.env.REACT_APP_API_URL_BACKEND_ECS
  };

  export default development;